import React from 'react';

export default function SecFilingDataTableHead() {
  return (
    <thead>
      <tr>
        <th className="col-sno">S.No.</th>
        <th className="col-company">Company</th>
        <th className="col-entity">Entity</th>
        <th className="col-type">Filing Type</th>
        <th className="col-priority">Priority</th>
        <th className="col-accepted">Accepted Date</th>
        <th className="col-date">Filing Date</th>
        <th className="col-file-film">
          <span className="sec-filing-insights-data-table__th-stacked">
            <span>File / Film No.</span>
          </span>
        </th>
      </tr>
    </thead>
  );
}
